import * as React from 'react';

import { Flex } from '@lightspeed/flame/Core';
import { Switch } from '@lightspeed/flame/Switch';
import { Text } from '@lightspeed/flame/Text';
import { getStore } from 'pages/store/selectors/employeeShops';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { useSelector } from 'react-redux';

interface Props {
  checked: boolean;
  disabled: boolean;
  onChange: () => void;
}

const AllShopsAccessSwitch: React.FC<Props> = ({ checked, disabled, onChange }) => {
  const { isPrimaryUser } = useSelector(getStore);

  return (
    <Flex justifyContent="space-between" px={1} py={2}>
      <Text color={isPrimaryUser ? theme.colors['gray-400'] : theme.colors.black}>
        Allow access to all
      </Text>
      <Switch
        checked={checked}
        css={{ padding: 0 }}
        data-testid="switch-access-all"
        disabled={disabled}
        onChange={onChange}
      />
    </Flex>
  );
};

export default AllShopsAccessSwitch;
